import { RELOAD_SET, RELOAD_SET_LAST } from "../actionNames";

const initialState = {
  lastReload: localStorage.getItem("lastReload"),
  shouldReload: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RELOAD_SET:
      return {
        ...state,
        shouldReload: action.shouldReload,
      };

    case RELOAD_SET_LAST:
      return {
        ...state,
        lastReload: action.lastReload,
      };

    default:
      return state;
  }
};

export default reducer;
